var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCitySolid = function SvgCitySolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47 8.47a.75.75 0 0 1 .78-.177V4A1.75 1.75 0 0 1 10 2.25h10A1.75 1.75 0 0 1 21.75 4v17a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75v-7a.75.75 0 0 1 .22-.53l5-5Zm4.78 5.84v5.94h-3.5V17a.75.75 0 0 0-1.5 0v3.25h-3.5v-5.94L8 10.06l4.25 4.25Zm0-7.31a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5H13a.75.75 0 0 1-.75-.75Zm3.99 0a.75.75 0 0 1 .75-.75H17a.75.75 0 0 1 0 1.5h-.01a.75.75 0 0 1-.75-.75Zm0 4a.75.75 0 0 1 .75-.75H17a.75.75 0 0 1 0 1.5h-.01a.75.75 0 0 1-.75-.75Zm0 4a.75.75 0 0 1 .75-.75H17a.75.75 0 0 1 0 1.5h-.01a.75.75 0 0 1-.75-.75Z",
    fill: "currentColor"
  })));
};
export default SvgCitySolid;